export const customEffortFormatter = estimatedEffort => {
  if (estimatedEffort > 90) {
    return {
      unit: 'hour',
      value: estimatedEffort / 60, //.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 0 }),
    }
  }
  return {
    unit: 'min',
    value: estimatedEffort,
  }
}
